import {useConnectionContext} from "../../contexts/connection";
import Tooltip from "../../components/common/utils/Tooltip";
import {DText, Flex} from "../../styles/MarketStyles";
import styled, {css, keyframes} from "styled-components";
import {useEffect, useState} from "react";
import {useSocket} from "../../contexts/socket";


const ConnectionStatus = () => {

    const socket = useSocket()
    // const { status } = useConnectionContext()
    const [latency, setLatency] = useState(0)

    /* latency */
    useEffect(() => {
        let interval;
        let start;
        if (socket) {
            interval = setInterval(
                () => {
                    start = Date.now()
                    socket.emit('ping')
                }
                , 1000)

            socket.on('pong', () => {
                setLatency(Date.now() - start)
            })

            socket.on('disconnect', () => {
                setLatency(null)
            })

        }

        return () => {
            if (interval) clearInterval(interval)
            if (socket) socket.off('ping')
        }
    }, [socket])

    return (
        <Tooltip
            content={!latency ? 'not-connected' : 'connected'}
            placement={'bottom'}
        >
            <Flex>
                <Flex align={'flex-end'} style={{ cursor: 'pointer', margin: '0 8px', direction: 'rtl' }}>
                    {[4, 3, 2, 1].map(item => (
                        <Bar key={item} idx={item} connected={!!latency}  />
                    ))}
                </Flex>
                <DText main fontSize={'ss'} style={{ marginBottom: '-4px' }}>
                    {!latency ? 'Disconnected' :
                        (
                            latency > 500 ?
                                'Unstable connection'
                                :
                                'Stable connection'
                        )
                    }
                </DText>
                <DText main fontSize={'ss'} style={{ marginBottom: '-4px', marginLeft: '5px' }}>
                    {latency} ms
                </DText>
            </Flex>

        </Tooltip>
    )
}


const animate = (theme, idx) => keyframes`
  ${(idx - 1) * 25}% {
    background-color: ${theme.color};
  }
  ${idx * 25}% {
    background-color: ${theme.mainOrange};
  }
  100%{
    background-color: ${theme.mainOrange};
  }
`

const Bar = styled.div`
  height: ${props => props.idx * 3}px;
  width: 2px;
  border-radius: 2px;
  background-color: ${props => props.connected ? props.theme.mainGreen : props.theme.color};
  margin: 0 1.5px;
  
  ${props => !props.connected && css`
    animation: ${props => animate(props.theme, props.idx)} 2s infinite forwards;
  `};
`

export default ConnectionStatus
